import React, { useEffect } from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const LineContent = ({data, elementId, title}) => {

    useEffect(() => {
        if (!data) return;

        const series = [
            { name: "Data do fato", data: data.incident ?? [] },
            { name: "Criação da solicitação", data: data.solicitation ?? [] },
            { name: "Finalização da solicitação", data: data.finalized ?? [] },
        ];

        const keys = [...new Set(series.flatMap(s => s.data.map(i => i.label)))].sort((a, b) => {
            const [dA, mA, yA] = a.split("/");
            const [dB, mB, yB] = b.split("/");
            return new Date(`${yA}-${mA}-${dA}`) - new Date(`${yB}-${mB}-${dB}`);
        });

        const dataColumns = series.map(({ name, data }) => {
            const values = keys.map(key => {
                const item = data.find(i => i.label === key);
                return Number(item?.value ?? 0);
            });

            return [name, ...values];
        });

        GraphicUtils.lineChart(elementId, dataColumns, keys);

    }, [data, elementId]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{title}</span>
                <div className="mt-1" id={elementId}></div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default LineContent;